import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_ServicePlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_ServicePlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h4> <b> SERVICE PLAN/PLAN DE SERVICIOS </b> </h4> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> CLIENT NAME: / NOMBRE DEL CLIENTE : </span> </td>
                        <td className='w-375'> <span className='eleHeader'> MEDICAID NUMBER: / NÚMERO DE MEDICAID: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMustBeUsedIn' name='cbMustBeUsedIn' className='add-only' value='INITIAL - MUST BE USED IN' /> INITIAL - MUST BE USED IN COMBINATION WITH SIGNATURE PAGE / INICIAL - DEBE USARSE JUNTO CON UNA PAGINA EN LA QUE APAREZCA LA FIRMA
                            <br />
                            <input type='checkbox' id='cbAddendum' name='cbAddendum' className='add-only' value='ADDENDUM' /> ADDENDUM/SUPLEMENTO
                            <br />
                            <input type='checkbox' id='cbProvidedClient' name='cbProvidedClient' className='add-only' value='PROVIDED CLIENT' /> PROVIDED CLIENT/PARENT/GUARDIAN WITH COPY OF SERVICE PLAN OR ADDENDUM/ SE ENTREGÓ AL CLIENTE/PADRE/TUTOR UNA COPIA DEL PLAN DE SERVICIOS O SUPLEMENTO.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> SERVICE NEED/SERVICIO NECESITADO: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtServiceNeed_1' name='txtServiceNeed_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <span className='eleHeader'> ACTION PLAN/PLAN DE ACCIÓN </span> </td>
                        <td className='w-200'> <span className='eleHeader'> BY WHOM/ POR QUIEN </span> </td>
                        <td className='w-200'> <span className='eleHeader'> BY WHEN/ PARA CUANDO </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_1' name='txtActionPlan_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_1' name='txtByWhom_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_1' name='txtByWhen_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_2' name='txtActionPlan_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_2' name='txtByWhom_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_2' name='txtByWhen_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_3' name='txtActionPlan_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_3' name='txtByWhom_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_3' name='txtByWhen_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> SERVICE NEED/SERVICIO NECESITADO: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtServiceNeed_2' name='txtServiceNeed_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <span className='eleHeader'> ACTION PLAN/PLAN DE ACCIÓN </span> </td>
                        <td className='w-200'> <span className='eleHeader'> BY WHOM/ POR QUIEN </span> </td>
                        <td className='w-200'> <span className='eleHeader'> BY WHEN/ PARA CUANDO </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_4' name='txtActionPlan_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_4' name='txtByWhom_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_4' name='txtByWhen_4' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_5' name='txtActionPlan_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_5' name='txtByWhom_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_5' name='txtByWhen_5' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_6' name='txtActionPlan_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_6' name='txtByWhom_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_6' name='txtByWhen_6' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> SERVICE NEED/SERVICIO NECESITADO: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtServiceNeed_3' name='txtServiceNeed_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <span className='eleHeader'> ACTION PLAN/PLAN DE ACCIÓN </span> </td>
                        <td className='w-200'> <span className='eleHeader'> BY WHOM/ POR QUIEN </span> </td>
                        <td className='w-200'> <span className='eleHeader'> BY WHEN/ PARA CUANDO </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_7' name='txtActionPlan_7' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_7' name='txtByWhom_7' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_7' name='txtByWhen_7' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_8' name='txtActionPlan_8' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_8' name='txtByWhom_8' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_8' name='txtByWhen_8' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <input type='text' id='txtActionPlan_9' name='txtActionPlan_9' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhom_9' name='txtByWhom_9' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtByWhen_9' name='txtByWhen_9' className='add-only' /> </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}











